/** Missing telemetry is not a zero; batch setup/cleanup is not response latency. */
export function validLatencyMs(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : null;
}

export function replayLatencyMs(replay: Record<string, unknown> | null): number | null {
  const latency = replay?.latency;
  if (!latency || typeof latency !== "object" || Array.isArray(latency)) return null;
  return validLatencyMs((latency as Record<string, unknown>).total_elapsed_to_message_ms);
}

export function formatLatency(value: number | null): string {
  return value == null ? "—" : `${(value / 1000).toFixed(1)}초`;
}
